import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Body1, Caption1, Link as FluentLink } from "@fluentui/react-components";
export const Link = forwardRef((props, ref) => {
    const { target, url, onLink, size, ...rest } = props;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const TextComponent = size === "small" ? Caption1 : Body1;
    return (_jsxs(FluentLink, { ref: ref, inline: true, target: target === "current" ? "_self" : "_blank", rel: "noopener noreferrer", href: url, onClick: onLink ?? undefined, ...rest, children: [props.children, _jsx(TextComponent, { children: props.value })] }));
});
Link.displayName = "Link";
//# sourceMappingURL=link.js.map